import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { useAppSelector } from './redux';
import { usePromotionVisibilityNowMs } from './use-promotion-visibility-now-ms';
import {
  buildAudienceContextFromState,
  getActiveAnnouncementBar,
} from '@common/utils/promotions';
import type { PromotionEntry } from '@common/types/promotions';
import type { StoreState } from '@common/types/store';

export function useActiveAnnouncementBar(): PromotionEntry | null {
  const location = useLocation();
  const items = useAppSelector((state: StoreState) => state.promotions.items);
  const dismissedKeys = useAppSelector((state: StoreState) => state.promotions.dismissedKeys);
  const audienceContext = useAppSelector(buildAudienceContextFromState);
  const nowMs = usePromotionVisibilityNowMs();

  const visibilityContext = useMemo(() => ({
    pathname: location.pathname,
    dismissedKeys,
    audienceContext,
  }), [location.pathname, dismissedKeys, audienceContext]);

  return useMemo(
    () => getActiveAnnouncementBar(items, {
      ...visibilityContext,
      now: moment(nowMs),
    }),
    [items, visibilityContext, nowMs],
  );
}
